import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/markPoint';
import { merge } from 'lodash';

import ChartService from './ChartService';
import { chartConfig } from '../charts';

export default class ChartLineService extends ChartService {
  // Converts line data into format for either numeric or categorical lines
  convertLineData(series, lineType) {
    if (lineType === 'value') {
      return series.map((point) => [point.x, point.y, point.threshold]);
    }
    return series.map((point) => point.y);
  }

  buildChartData(visualization) {
    const symbols = visualization.symbols || Object.values(chartConfig.symbols);

    const paths = Object.keys(visualization.data).map((_, index) => symbols[index % symbols.length]);

    const colors = visualization.colors || this.defaultChartOptions.color;

    const tooltipFnc = (visualization.tooltip || {}).fnc || ((item) => `${item.seriesName}: ${item.value}`);

    const tooltipOptions = {
      item: (item) => {
        return `${item.name} <br />
            <svg viewBox="0 0 12 12" height="12" width="12" style="margin: 0 5px 0 0; position: relative; top: 1px;">
              <path fill="${item.color}" d="${paths[item.seriesIndex]}"/>
            </svg>
            ${tooltipFnc(item)}
            `;
      },
      axis: (items) => {
        let str = `${items[0].name} <br />`;

        str += items.map((item) => {
          return `
          <svg viewBox="0 0 12 12" height="12" width="12" style="margin: 0 5px 0 0; position: relative; top: 1px;">
            <path fill="${item.color}" d="${paths[item.seriesIndex]}"/>
          </svg>
          ${tooltipFnc(item)}
          `;
        }).join('<br />');

        return str;
      }
    };

    const tooltipTrigger = (visualization.tooltip || {}).trigger || 'axis';

    const options = {
      grid: {
        bottom: visualization.dataZoom ? '10%' : '6%',
        containLabel: true,
        left: '6%',
        right: '6%',
        top: '10%'
      },

      series: Object.keys(visualization.data).map((seriesName, index) => ({
        data: this.convertLineData(visualization.data[seriesName], visualization.lineChartType),
        markPoint: {
          label: { color: 'white' },
          symbolSize: 60,
          data: visualization.data[seriesName]
            .map((f, ind) => ({
              xAxis: ind,
              yAxis: f.y,
              ...(f.marker || {}),
            }))
            .filter(f => f.value)
        },
        hoverAnimation: false,
        name: seriesName,
        type: 'line',
        symbol: `path://${paths[index]}`,
        symbolSize: 10
      })),
      tooltip: {
        trigger: tooltipTrigger,
        formatter: tooltipOptions[tooltipTrigger]
      },

      xAxis: {
        axisLabel: {
          color: '#000',
          fontSize: 11
        },
        axisLine: {
          lineStyle: {
            color: '#767676'
          }
        },
        axisTick: {
          lineStyle: {
            color: '#767676'
          }
        },
        boundaryGap: false,
        data: [...visualization.labels],
        type: 'category'
      },

      yAxis: {
        axisLabel: {
          fontSize: 13,
          margin: 30
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        nameGap: 70,
        nameLocation: 'center',
        nameTextStyle: {
          fontWeight: 'bold',
          fontSize: 13
        },
        type: 'value'
      },
      dataZoom: visualization.dataZoom,
    };
    return merge(this.defaultChartOptions, {
      ...options,
      color: colors,
      forceRedraw: visualization.forceRedraw,
      seriesColors: Object.keys(visualization.data).map((key, index) => ({
        key,
        color: colors[index % colors.length],
        label: key,
        path: paths[index]
      }))
    });
  }
}
